<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span class="bind">会员列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">用户名：</label>
              <el-input
                v-model.trim="searchData.username"
                class="jm-input175"/>
            </div>
            <div class="box-content">
              <label class="form-tit">昵称(论坛查询)：</label>
              <el-input
                v-model.trim="searchData.nickname"
                class="jm-input175"/>
            </div>
            <div class="box-content">
              <label class="form-tit">手机：</label>
              <el-input
                v-model.trim="searchData.tel"
                class="jm-input175"/>
            </div>
            <div class="box-content">
              <label class="form-tit">云申请：</label>
              <el-select v-model="searchData.value" placeholder="请选择" class="jm-input135">
                <el-option
                  v-for="item in is_yun"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">注册时间：</label>
              <el-date-picker
                :clearable = "false"
                v-model="dateRange"
                type="daterange"/>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">渠道来源：</label>
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable/>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="sendForm">开始查询</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetForm">清空条件</el-button>
          </div>
          <jm-tableList
            url="/index/member/memberList"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="160">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="moveEdit(scope.row)">编辑</el-button>
                <el-button
                  v-if="{admin}"
                  size="small"
                  type="danger"
                  @click="deleteData(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';
import { filterVisible } from '@/utils/utils';
import { jmChannel, } from '@/components/tool';

export default {
  data() {
    return {
      dateRange: [],
      searchData: {
        add_time_start: '',
        add_time_end: '',
        tel: '',
        qq: '',
        weixin: '',
        nickname: '',
        username: '',
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: ''
        },
        value: '0',
      },
      disabled: false,
      is_yun: [{
        value: '0',
        label: '全部'
      }, {
        value: '2',
        label: '是'
      }, {
        value: '1',
        label: '否'
      }],
      refresh: false,
      admin: false,
      crm_writer: '',
      selectVal: [],
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmChannel,
    jmDictSelect,
  },
  created() {
    this.$http._post({
      url: '/index/member/getPower',
    }).then(({ data }) => {
      this.admin = data;
    });
  },
  methods: {
    // 表单提交
    sendForm() {
      this.refresh = true;
    },
    // 重置表单
    resetForm() {
      this.searchData.tel = '';
      this.searchData.qq = '';
      this.searchData.weixin = '';
      this.searchData.nickname = '';
      this.searchData.username = '';
      this.searchData.add_time_start = '';
      this.searchData.add_time_end = '';
      this.dateRange = '';
      this.searchData.value = '0';
      this.searchData.channel.custom_from = '';
    },
    filterVisible,
    // 跳转页面
    moveEdit(val) {
      let url = '/frontend/Member/edit?id=';
      window.location.href = url + val.userid;
    },
    // 删除数据
    deleteData(val) {
      this.$confirm('此操作将删除此条信息，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http._post({
          url: '/index/member/del',
          data: {
            userId: val.userid,
            toUserId: val.touserid,
          },
        }).then(({ data }) => {
          this.$message.success('删除成功');
          this.refresh = true;
          console.log(data);
        });
      });
    },
  },
  watch: {
    dateRange(data) {
      let s = data[0];
      let e = data[1];
      this.searchData.add_time_start = s ? `${s.getFullYear()}-${s.getMonth() + 1}-${s.getDate()}` : '';
      this.searchData.add_time_end = e ? `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}` : '';
    }
  }
};
</script>

